import axios from "axios";

const postApi = async (url, data, isFormData = false) => {
  try {
    const response = await axios.post('url', data, {
      headers: {
        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        'X-Requested-With': 'XMLHttpRequest',
      },
      withCredentials: true,
    });
    // const response = await axios.post(url, data, config);
    return response.data;
  } catch (error) {
    console.error("POST Request Error:", error);

    if (error.response) {
      return {
        success: false,
        status: error.response.status,
        message: error.response.data?.message || "Request failed",
      };
    }

    return { success: false, message: error.message };
  }
};

export default postApi;
